export enum SidebarAdditionalAccountTypesEnum {
  ADMIN = 'admin',
}
